import { keepPreviousData, useQuery } from "@tanstack/vue-query";

import { pb } from "#api/pocketbase";

// NOTE: Query keys used for invalidation should require all arguments, as 'undefined' in query key
//         prevents invalidating any queries with similar key but that do provide args for that argument!
export const appKeys = {
  healthCheck: ["api", "healthCheck"],
} as const;

export const useApiHealthcheck = () => {
  return useQuery({
    placeholderData: keepPreviousData,
    queryKey: appKeys.healthCheck,
    queryFn: async () => {
      return pb.health.check();
    },
  });
};
